import { zodResolver } from '@hookform/resolvers/zod'
import { FieldValues, UseFormProps, UseFormReturn, useForm as useRHForm } from 'react-hook-form'
import { ZodSchema } from 'zod'

export function useForm<
  TFieldValues extends FieldValues = FieldValues,
  TContext = any,
  TTransformedValues extends FieldValues | undefined = undefined,
>({
  defaultValues,
  rules,
  mode,
  shouldFocusError,
  ...props
}: UseFormProps<TFieldValues, TContext> & { rules?: ZodSchema<TFieldValues> } = {}): UseFormReturn<
  TFieldValues,
  TContext,
  TTransformedValues
> {
  return useRHForm({
    defaultValues,
    resolver: rules && zodResolver(rules),
    mode: mode || 'onChange',
    shouldFocusError: shouldFocusError === undefined ? true : shouldFocusError,
    ...props,
  });
}
